import { superCodeActions, service } from '..';

 const createSuperCodeEndpoint = 'supercode';
 const identifyBomEndpoint = 'supercode/identify';
 const saveToSapEndpoint = 'supercode/savetosap';


 export const superCodeService = {
  create: input  => {
    return service( createSuperCodeEndpoint )
    .post( input.data ).then(
      response => ( { type:superCodeActions.CREATED, data:response.data } )
    )
  },

  identify: input =>{
    return service( identifyBomEndpoint )
    .post( input.data ).then( 
      response => response.data ? ( { data: response.data, type: superCodeActions.IDENTIFIED } ) : console.error("Error in identifying configuration")
    )
  },

  saveToSap: input => {
    return service( saveToSapEndpoint )
    .post( input.data )
  }
} 